import React from 'react';
import { RouteComponentProps, useHistory, withRouter } from 'react-router-dom';

import ScrollToTop from '@app/components/LocalCommon/ScrollToTop/ScrollToTop';
import FindVetBlock from '@app/components/UI/FindVetBlock/FindVetBlock';
import Footer from '@app/components/UI/Footer/Footer';
import Header from '@app/components/UI/Header/Header';
import '@app/scss/style.scss';

type PageProps = RouteComponentProps & { withScrollTop: boolean };

const LayoutFamilyResources: React.FC<PageProps> = ({ children, withScrollTop = true, ...rest }) => {
	const history = useHistory();

	return (
		<div className="app-container">
			<Header />
			<div className="app-container-content">{children}</div>
			<FindVetBlock />
			<Footer />
			{withScrollTop && <ScrollToTop />}
		</div>
	);
};

export default withRouter(LayoutFamilyResources) as any;
